var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4444 0.115754C12.7016 -0.0385846 13.0257 -0.0385846 13.2778 0.115754L25.3363 7.46742C25.5781 7.61661 25.7222 7.87389 25.7222 8.15684V15.7708H22.3936C21.2824 15.7708 20.2692 16.2287 19.5335 16.9643C18.7979 17.7 18.3451 18.7135 18.3451 19.8248V27.8915L15.4383 29.6612C14.9033 29.9904 14.214 29.6047 14.214 28.977V15.174C14.214 14.8962 14.07 14.6338 13.8282 14.4898L2.4745 7.57028C1.9652 7.25646 1.9652 6.51054 2.4745 6.19671L12.4444 0.115754ZM1.22432 10.1015C0.689294 9.77226 0 10.158 0 10.7857V22.9373C0 23.2202 0.149189 23.4774 0.385833 23.6266L10.2838 29.6612C10.824 29.9904 11.5082 29.6047 11.5082 28.977V16.8203C11.5082 16.5425 11.3641 16.2802 11.1223 16.1361L1.22432 10.1015Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6932 33.1182H30.6983C31.4957 32.7529 32 31.9708 32 31.0911V21.1158C32 19.5467 30.7241 18.2605 29.1499 18.2605H23.6812C22.1121 18.2605 20.8364 19.5467 20.8364 21.1158V31.0911C20.8364 31.9708 21.3353 32.7529 22.1379 33.1182H22.1431C22.9457 33.4783 23.8563 33.3445 24.5199 32.7683L24.5249 32.7631L26.4182 31.1014L28.3062 32.758C28.3113 32.758 28.3112 32.7631 28.3112 32.7631C28.9748 33.3496 29.8959 33.4783 30.6932 33.1182Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/BookingIcon.f04aa35616bf738e287d24253efa608b.svg";
export { ForwardRef as ReactComponent };